import { get } from '@shared/adapters/lodash'
import type { InvestmentDetail, VaspHolding } from '../../types/investmentDetailTypes'

const toArray = (value: unknown): unknown[] => (Array.isArray(value) ? value : [])

const parseVaspHolding = (resp: unknown): VaspHolding | null => {
  const holding = get(resp, 'data.vaspHolding')
  if (!holding) return null
  return {
    tokenQuantity: Number(get(holding, 'tokenQuantity') ?? 0),
    status: get(holding, 'status') ?? '',
    certificateUrl: get(holding, 'certificateUrl') ?? '',
    lastSyncedAt: get(holding, 'lastSyncedAt') ?? '',
    documents: toArray(get(holding, 'documents')).map((doc) => ({
      documentId: get(doc, 'documentId') ?? '',
      documentType: get(doc, 'documentType') ?? '',
      documentTitle: get(doc, 'documentTitle') ?? '',
      fileName: get(doc, 'fileName') ?? '',
      filePath: get(doc, 'filePath') ?? '',
      mimeType: get(doc, 'mimeType') ?? '',
      issuedAt: get(doc, 'issuedAt') ?? '',
    })),
  }
}

export const parseInvestmentDetail = (resp: unknown): InvestmentDetail => ({
  propertyOverview: {
    propertyName: get(resp, 'data.propertyOverview.propertyName') ?? '',
    propertyLocation: get(resp, 'data.propertyOverview.propertyLocation') ?? '',
    coverImage: get(resp, 'data.propertyOverview.coverImage') ?? '',
  },
  documents: toArray(get(resp, 'data.documents')).map((doc) => ({
    id: get(doc, 'id') ?? '',
    documentType: get(doc, 'documentType') ?? '',
    documentTitle: get(doc, 'documentTitle') ?? '',
    filePath: get(doc, 'filePath') ?? '',
  })),
  investmentSummary: {
    investedAmount: Number(get(resp, 'data.investmentSummary.investedAmount') ?? 0),
    currentInvestmentValue: Number(get(resp, 'data.investmentSummary.currentInvestmentValue') ?? 0),
    currency: get(resp, 'data.investmentSummary.currency') ?? 'AED',
    totalReturnsAmount: Number(get(resp, 'data.investmentSummary.totalReturnsAmount') ?? 0),
    totalReturnsPercentage: Number(get(resp, 'data.investmentSummary.totalReturnsPercentage') ?? 0),
    rentalIncomeEarned: Number(get(resp, 'data.investmentSummary.rentalIncomeEarned') ?? 0),
  },
  tokenDetails: {
    tokenName: get(resp, 'data.tokenDetails.tokenName') ?? '',
    tokensHeld: Number(get(resp, 'data.tokenDetails.tokensHeld') ?? 0),
    ownershipPercentage: Number(get(resp, 'data.tokenDetails.ownershipPercentage') ?? 0),
    initialTokenPrice: Number(get(resp, 'data.tokenDetails.initialTokenPrice') ?? 0),
  },
  investmentInfo: {
    investmentDate: get(resp, 'data.investmentInfo.investmentDate') ?? '',
    projectedRoi: Number(get(resp, 'data.investmentInfo.projectedRoi') ?? 0),
  },
  vaspHolding: parseVaspHolding(resp),
})
